var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1356_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 8.25V5.125C18.1875 4.2962 17.8583 3.50134 17.2722 2.91529C16.6862 2.32924 15.8913 2 15.0625 2H4.125C3.2962 2 2.50134 2.32924 1.91529 2.91529C1.32924 3.50134 1 4.2962 1 5.125V23.875C1 24.7038 1.32924 25.4987 1.91529 26.0847C2.50134 26.6708 3.2962 27 4.125 27H15.0625C15.8913 27 16.6862 26.6708 17.2722 26.0847C17.8583 25.4987 18.1875 24.7038 18.1875 23.875V20.75",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 14.5H29.125M29.125 14.5L24.4375 9.8125M29.125 14.5L24.4375 19.1875",
    stroke: "#8B659C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1356_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutP);
export default __webpack_public_path__ + "static/media/logout-p.3e070c14cc8d8bbb2eb50bfe41832b92.svg";
export { ForwardRef as ReactComponent };